﻿// assets/ds-eyedropper.js
// Pictoirel Design Studio - Color Eyedropper (v3)
(function() {
  'use strict';

  var _activeTarget = null; // 'text' | 'fill' | 'stroke'
  var _cursorStyle = null;

  function hexFromRgb(r, g, b) {
    return '#' + [r, g, b].map(function(v) {
      return ('0' + v.toString(16)).slice(-2);
    }).join('');
  }

  function startEyedropper(target) {
    if (!window.fabricCanvas) return;
    _activeTarget = target;
    var container = window.fabricCanvas.wrapperEl || document.getElementById('ds-canvas-container');
    if (container) {
      _cursorStyle = container.style.cursor;
      container.style.cursor = 'crosshair';
    }

    window.fabricCanvas.once('mouse:down', function(opt) {
      var e = opt.e;
      var pointer = window.fabricCanvas.getPointer(e, true);
      try {
        var ctx = window.fabricCanvas.getElement().getContext('2d');
        var pixel = ctx.getImageData(Math.round(pointer.x), Math.round(pointer.y), 1, 1).data;
        var hex = hexFromRgb(pixel[0], pixel[1], pixel[2]);
        applyColor(hex);
      } catch(err) {
        console.warn('Eyedropper error:', err);
      }
      if (container) container.style.cursor = _cursorStyle || '';
      _activeTarget = null;
    });
  }

  function applyColor(hex) {
    if (!window.fabricCanvas) return;
    var obj = window.fabricCanvas.getActiveObject();
    if (!obj) return;
    if (_activeTarget === 'text') {
      if (obj.type === 'i-text' || obj.type === 'text') {
        obj.set('fill', hex);
        window.fabricCanvas.renderAll();
        var tc = document.getElementById('ds-text-color');
        try { if (tc) tc.value = hex; } catch(e) {}
        if (window.saveHistory) window.saveHistory();
      }
    } else if (_activeTarget === 'fill') {
      if (obj.isShape) {
        obj.set('fill', hex);
        window.fabricCanvas.renderAll();
        var sf = document.getElementById('ds-shape-fill');
        try { if (sf) sf.value = hex; } catch(e) {}
        if (window.saveHistory) window.saveHistory();
      }
    } else if (_activeTarget === 'stroke') {
      if (obj.isShape) {
        obj.set('stroke', hex);
        window.fabricCanvas.renderAll();
        var ss = document.getElementById('ds-shape-stroke');
        try { if (ss) ss.value = hex; } catch(e) {}
        if (window.saveHistory) window.saveHistory();
      }
    }
  }

  window.activateEyedropper = startEyedropper;
})();
